import {
  Alert,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useProjects } from '../api/hooks'
import { projectRoleLabels, statusLabels } from '../api/types'
import { formatDate, formatEUR2, formatPct } from '../format'
import { useAmountsHidden } from '../privacy'
import PrivacyToggle from '../components/PrivacyToggle'

export default function ProjectsPage() {
  const { data, loading, error } = useProjects()
  useAmountsHidden()

  return (
    <Box>
      <Stack direction="row" sx={{ mb: 3, justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4">Projets</Typography>
        <PrivacyToggle />
      </Stack>

      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}

      {data && data.length === 0 && (
        <Card>
          <CardContent>
            <Typography sx={{ color: 'text.secondary' }}>
              Aucun projet. Ouvrez une simulation et cliquez sur « Créer un projet ».
            </Typography>
          </CardContent>
        </Card>
      )}

      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
        }}
      >
        {data?.map((p) => (
          <Card key={p.id}>
            <CardActionArea component={RouterLink} to={`/projects/${p.id}`} sx={{ height: '100%' }}>
              <CardContent>
                <Stack
                  direction="row"
                  sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}
                >
                  <Typography variant="h6">{p.name}</Typography>
                  <Stack direction="row" spacing={1}>
                    <Chip size="small" label={statusLabels[p.status]} />
                    {!p.isOwner && (
                      <Chip size="small" variant="outlined" label={projectRoleLabels[p.role]} />
                    )}
                  </Stack>
                </Stack>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {formatDate(p.createdAt)}
                </Typography>
                {p.simulation ? (
                  <Stack sx={{ mt: 2 }} spacing={0.5}>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      Simulation : {p.simulation.name}
                    </Typography>
                    <Typography variant="body2">
                      {formatEUR2(p.simulation.results.monthlyCashFlow)}/mois ·{' '}
                      {formatPct(p.simulation.results.netYield)} net
                    </Typography>
                  </Stack>
                ) : (
                  <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2 }}>
                    Sans simulation liée
                  </Typography>
                )}
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  )
}
